export const formatNumber = (value: number | null | undefined, maximumFractionDigits = 5) =>
	value === undefined || value === null ? '—' : value.toLocaleString('pt-BR', { maximumFractionDigits });

export const formatBand = (min: number | undefined, max: number | undefined) => {
	if (min === undefined && max === undefined) return 'Sem faixa';
	if (min === undefined) return `Menor que ${formatNumber(max)}`;
	if (max === undefined) return `A partir de ${formatNumber(min)}`;
	return `${formatNumber(min)} a ${formatNumber(max)}`;
};

export const applyScale = (value: number | undefined, scale: number) =>
	value === undefined ? undefined : Number((value * scale).toPrecision(12));

export const removeScale = (value: number | undefined, scale: number) =>
	value === undefined ? undefined : Number((value / scale).toPrecision(12));

export const pluralize = (count: number, singular: string, plural: string) =>
	`${count} ${count === 1 ? singular : plural}`;
